import { render, staticRenderFns } from "./bcbmTable.vue?vue&type=template&id=2ab7dddf&scoped=true"
import script from "./bcbmTable.vue?vue&type=script&lang=ts"
export * from "./bcbmTable.vue?vue&type=script&lang=ts"
import style0 from "./bcbmTable.vue?vue&type=style&index=0&id=2ab7dddf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab7dddf",
  null
  
)

export default component.exports